import { Autocomplete, CircularProgress, createFilterOptions, TextField } from '@mui/material';
import { useMapsLibrary } from '@vis.gl/react-google-maps';
import { useEffect, useState } from 'react';
import { MdLocationPin } from "react-icons/md";

const filter = createFilterOptions();

const CustomPlaceAutocomplete = ({ id, onChange, value = '', label = '', error, helperText, variant = 'standard', inputSize = "medium", isRequired = true, disabled=false }) => {
    const [inputValue, setInputValue] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);

   

    // Use a debounce to prevent excessive API calls
    useEffect(() => {
        const fetchPredictions = async () => {
            const { AutocompleteSessionToken, AutocompleteSuggestion } = await google.maps.importLibrary("places");
            if (inputValue.length < 3) {
                setSuggestions([]);
                return;
            }

            setLoading(true);

            let request = {
                input: inputValue,
                language: "en-US",
                region: "us",
            };

            const token = new AutocompleteSessionToken();
            request.sessionToken = token;
            // Fetch autocomplete suggestions.
            const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
            const placeList = suggestions.map(data => data?.placePrediction?.text?.toString());
            setSuggestions(placeList);
            setLoading(false);
        };
        // Debounce the API call
        const debounceTimeout = setTimeout(fetchPredictions, 300);

        return () => clearTimeout(debounceTimeout);
    }, [inputValue]);


  
    return (
        <Autocomplete
            id={id}
            options={suggestions}
            autoHighlight
            fullWidth
            defaultValue={value || ''}
            onChange={(e, val) => {
                onChange?.(val)
                if (!val) {
                    setSuggestions([])
                }
            }}
            freeSolo
            disabled={disabled}
            size={inputSize}
            disableCloseOnSelect={false}
            getOptionLabel={(option) => option ?? ''}
            renderOption={(props, option) => {
                const { key, ...optionProps } = props;
                return (
                    <li
                        key={key}

                        style={{

                            display: 'flex',
                            alignItems: 'flex-Start',
                            gap: '5px',
                            zIndex: 10
                        }}
                        {...optionProps}
                    >
                        <div style={{ height: '20px', width: '20px', marginTop: '4px' }}>
                            <MdLocationPin style={{ color: 'red' }} />
                        </div>
                        <p style={{ margin: 0, padding: 0 }}>
                            {option}
                        </p>
                    </li>
                );
            }}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);

                // ✅ If typed value is not in suggestions, add it to the dropdown
                if (params.inputValue !== "" && !options.includes(params.inputValue)) {
                    filtered.push(params.inputValue);
                }

                return filtered;
            }}
            renderInput={(params) => (
                <TextField
                    error={error}
                    helperText={error && helperText}
                    fullWidth
                    className='user-profile-text-input'
                    variant={variant}
                    size={inputSize}
                    required={isRequired}
                    placeholder='Type 3 or more characters to search'
                    {...params}
                    label={label}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress sx={{ color: 'var(--hoverColorBold)' }} size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                    slotprops={{
                        htmlInput: {
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                        },
                    }}
                    onChange={(e) => {
                        setInputValue(e.target.value)
                    }}
                />
            )}
        />
    )
}

export default CustomPlaceAutocomplete